import { makeStyles } from '@material-ui/core';
import paleta from '../../configuraciones/paleta';

const styles = makeStyles((theme) => ({
  root: {
    height: '100%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.only('xs')]: {
      overflow: 'auto',
    },
    border: `1px solid rgba(36, 36, 36, 0.1)`,
    position: 'relative',
  },
  table: {
    height: '100%',
    overflow: 'auto',
    '& .MuiTableCell-head, .MuiTableRow-root': {
      borderBottom: `1px solid ${paleta.tabla.bordertd}`,
      '&:last-child': {
        borderRight: 'none',
      }
    },
    '& .MuiTableCell-head': {
      padding: theme.spacing(1),
      backgroundColor: paleta.sidebar.active,
      userSelect: 'none',
      '& span': {
        fontSize: 12,
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableCell-body': {
      padding: theme.spacing(0.5, 2),
      borderBottom: 'none',
    }
  },
  label: {
    fontWeight: 600,
    fontSize: 16,
  },
  labelSinRegistros: {
    fontWeight: 600,
    fontSize: 16,
    textAlign: 'center',
    width: '100%',
  },
  btnAdd: {
    backgroundColor: '#F4F9FD',
    color: '#1F2129',
    textTransform: 'none',
    boxShadow: 'none',
  },
  btnAction: {
    margin: theme.spacing(0.5),
  },
  actions: {
    minWidth: 100,
    textAlign: 'center',
  },
  rowHover: {
    backgroundColor: 'initial',
    '&:hover': {
      backgroundColor: '#F4F9FD',
    },
  },
  rowError: {
    backgroundColor: `${paleta.tabla.rowError}AA`,
    '&:hover': {
      backgroundColor: `${paleta.tabla.rowError}77`,
    },
  }
}));

export default styles;
